import '../styles/global.scss';
import '@splidejs/splide/css';
import './components/menu.js';
import './components/footer-accordion';
import './components/header-mob-accordion';
import './components/cookies';
import ScreenSizeDetector from 'screen-size-detector';

const headerWrapper = document.querySelector('.header__wrapper');
const header = document.querySelector('.header');

const makeHeaderFixed = function (e) {
    headerWrapper.style.position = 'fixed';
    headerWrapper.style.boxShadow = '0px 3px 6px rgba(0, 0, 0, 0.16)';
    headerWrapper.style.top = '0';
    if (window.scrollY < 3)
        headerWrapper.style.boxShadow = 'none';
    headerWrapper.style.top = '-5px';
    header.style.marginTop = '61px';
}

const defaultOptions = {
    widthDefinitions: { // Width definitions object. Can be overwritten, added or removed
        tablet: {
            min: 0,
            max: 768,
            inclusion: "[]",
            onEnter: () => {
                window.addEventListener('scroll', makeHeaderFixed);
            },
            onLeave: () => {
                window.removeEventListener('scroll', makeHeaderFixed);
                headerWrapper.style.position = 'relative';
                headerWrapper.style.boxShadow = 'none';
                header.style.marginTop = '0';
            },
        },
    },
};

// Use it like so:
const screen = new ScreenSizeDetector(defaultOptions);